import * as styles from './spacer.module.css';

const Spacer = ({height}: {height: string}) => (
    <div className={styles.spacer} style={{height}}/>
);

export default Spacer;
